import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// import hooks
import { useEffect } from "react";
import useBooleanState from "../../../../hooks/useBoolean/useBoolean.hook.js";
import Typography from "../../../../components/atoms/Typography/index.js";
import IconButton from "../../../../components/atoms/IconButton/index.js";
import { CustomNextButton, CustomPreviousButton, FeatureDiscoveryPaper, FooterBox, FooterContentBox, FooterNavigationBox, } from "../FeatureDiscovery.components.js";
import { CENTUPLE, SINGLE, TRIPLE, VIGINTUPLE, ZERO } from "../../../../constants/numbers.consts.js";
import isLastIndex from "../../../../common-utils/array/isLastArrayIndex.util.js";
const FeatureDiscoveryTooltip = ({ tooltipPosition, steps, totalSteps, currentStep, closeFeatureDiscoveryHandler, goToNextStep, goToPreviousStep, offset, text, }) => {
    const visibility = useBooleanState(false);
    const rendering = useBooleanState(false);
    useEffect(() => {
        // Trigger fade-in effect after mounting
        const timer = setTimeout(() => {
            visibility.setTrue();
        }, ZERO);
        // Add transition for subsequent renders
        const renderTimer = setTimeout(() => {
            rendering.setTrue();
        }, CENTUPLE); // Match the duration of the initial fade-in
        return () => {
            clearTimeout(timer);
            clearTimeout(renderTimer);
        };
    }, [rendering, visibility]);
    return (_jsxs(FeatureDiscoveryPaper, { tooltipPosition: tooltipPosition, offset: offset, isVisible: visibility.value, hasRendered: rendering.value, children: [_jsx(IconButton, { onClick: closeFeatureDiscoveryHandler, component: "button", type: "xmark", sx: {
                    position: "absolute",
                    top: ZERO,
                    right: ZERO,
                    zIndex: VIGINTUPLE,
                    color: ({ vars }) => vars.palette.common.white,
                }, iconProps: {
                    sx: { color: ({ vars }) => vars.palette.common.white },
                } }), _jsx(Typography, { variant: "title", component: "div", prominent: true, sx: { textWrap: "balance" }, children: steps[currentStep].title }), _jsx(Typography, { variant: "body", sx: {
                    py: TRIPLE,
                }, children: steps[currentStep].description }), _jsx(FooterBox, { children: _jsxs(FooterContentBox, { children: [_jsx(Typography, { variant: "body", size: "medium", sx: {
                                py: TRIPLE,
                            }, children: totalSteps > SINGLE && text.pagination ? text.pagination({ currentStep, totalSteps }) : "" }), _jsxs(FooterNavigationBox, { children: [_jsx(CustomPreviousButton, { onClick: goToPreviousStep, disabled: currentStep === 0, variant: "text", children: text.previous }), _jsx(CustomNextButton, { onClick: goToNextStep, variant: "contained", children: isLastIndex(currentStep, steps) ? text.done : text.next })] })] }) })] }));
};
export default FeatureDiscoveryTooltip;
